const attributes = [
  { benefit: 'deductible', filter: 'deductible' },
  { benefit: 'lifetimeMax', filter: 'coverage' },
  { benefit: 'userCoinsurance', filter: 'coinsurance' },
  { benefit: 'outOfPocketMax', filter: 'moop' }
]

function findAlternativePlan({
  planTypeKey,
  planIds,
  filters,
  filtersByProductType,
  plans
}: {
  filters: { filterName: string; filterValue: string }[]
  planTypeKey: string
  planIds: number[]
  filtersByProductType: { [key: string]: PlanFilter }
  plans: Array<Plan>
}): Plan {
  const filterResults = {}

  filters.forEach(filter => {
    const attribute = attributes.find(att => att.filter === filter.filterName)
    if (attribute) {
      filterResults[attribute.benefit] = +filter.filterValue
    }
  })

  const availablePlans = planIds.filter(planId => {
    const plan = plans[planId]

    return Object.keys(filterResults).reduce((accum, current) => {
      return accum && +plan.coreBenefits[current] === +filterResults[current]
    }, true)
  })

  const occurrences = {}

  availablePlans.forEach(planId => {
    const plan = plans[planId]
    occurrences[planId] = 0

    attributes.forEach(attribute => {
      if (
        +plan.coreBenefits[attribute.benefit] ===
        +(
          filterResults[attribute.benefit] ||
          filtersByProductType[planTypeKey][attribute.filter]
        )
      ) {
        occurrences[planId] = occurrences[planId] + 1
      }
    })
  })

  let max = 0
  let changedPlanId = undefined
  Object.keys(occurrences).forEach(planId => {
    if (occurrences[planId] > max) {
      changedPlanId = planId
      max = occurrences[planId]
    }
  })

  return plans[changedPlanId]
}

export default findAlternativePlan
